import React, { useState } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import {
  Modal, Input, Button, Slider, message
} from 'antd'
import SmsCodeVerify from '@/components/rc-sms-verify'
import ImgVerify from '@/components/rc-img-verify'
import {
  $cookie,
  isPhone,
  isCode,
  floatMultiple,
  sessionstorage,
  getSuccessMsg
} from '$utils'
import { intentCommon } from '../service'
import { UseIntentOrderExt } from '../order-ext'
import { UseModalSuccess } from '../success'
import './styles.scss'
import $dom from '../../../util'

// 降价提醒引导弹窗
const IntentDiscountNotifyGuide = (props) => {
  const { submitParams, otherParams } = props
  const { onClose } = props
  const [visible, setVisible] = useState(props.visible)
  const defaultPriceTo = floatMultiple(Number(submitParams.owner_price), 0.95)
  const [priceTo, setPriceTo] = useState(defaultPriceTo) // 初始化价格95%
  const [mobileNumber, setMobileNumber] = useState(
    $cookie.get('rrc_login_phone') || sessionstorage.get('intentPhone') || ''
  )
  const [errMsg, setErrMsg] = useState()
  // 图形验证码
  const [imgVerify, setImgVerify] = useState(false)
  const [imgVerifyCode, setImgVerifyCode] = useState(false)

  // 短信验证码
  const [smsVerify, setSmsVerify] = useState(false)
  const [smsVerifyCode, setSmsVerifyCode] = useState(true)

  const LOWDISCOUNT = 0.7 // 滑动条滑动到最左边最低折扣率7折
  const salePrice = Number(submitParams.owner_price) // 车主报价
  const lowPrice = Number((salePrice * LOWDISCOUNT).toFixed(2)) // 滑动条左侧最低价格
  const centerPrice = Number(((salePrice * (1 + LOWDISCOUNT)) / 2).toFixed(2))
  const getPriceLevel = (progress) => {
    const priceDiff = salePrice - lowPrice
    const price1of6 = lowPrice + priceDiff * (1 / 6)
    const price3of6 = lowPrice + priceDiff * (3 / 6)
    const price5of6 = lowPrice + priceDiff * (5 / 6)
    let type = 0
    if (progress > price5of6) {
      type = 4
    } else if (progress >= price3of6 && progress <= price5of6) {
      type = 3
    } else if (progress > price1of6 && progress < price3of6) {
      type = 2
    } else {
      type = 1
    }
    return type
  }
  const [priceLevel, setPriceLevel] = useState(getPriceLevel(defaultPriceTo)) // 出价等级：更换头像位置、界面反馈信息
  const sliderOption = {
    value: priceTo,
    onChange: (value) => {
      setPriceTo(value)
      setPriceLevel(getPriceLevel(value))
    },
    style: { width: '90%', margin: '50px auto' },
    marks: {
      [lowPrice]: `${lowPrice}万`,
      [centerPrice]: `${centerPrice}万`,
      [salePrice - 0.0001]: {
        label: '车主报价',
        style: { marginTop: '2px' }
      },
      [salePrice]: {
        label: `${salePrice}万`,
        style: { marginTop: '20px ' }
      }
    },
    min: lowPrice,
    max: salePrice,
    step: 0.01,
    tipFormatter: value => `${value.toFixed(2)}万`,
    tooltipVisible: true,
    getTooltipPopupContainer: () => document.getElementsByClassName('ant-slider-handle')[0] // 要指定挂载容器，否则页面滚动时展示会错位
  }
  const closeModal = () => {
    global.$rbl.push('car-detail_pricenotificationpop_close')
    setVisible(false)
    onClose && onClose()
  }
  // 降价提醒线索提交
  const discountSubmit = async (isrefresh) => {
    const _isrefresh = isrefresh && isrefresh === true
    if (!_isrefresh) {
      global.$rbl.push(submitParams.submit_sources)
      global.$rbl.push({
        event: 'car-detail_详情页线索引导弹层-降价通知_按钮',
        content: {
          param: submitParams.submit_sources
        }
      })
    }
    setErrMsg('')
    if (!isPhone(mobileNumber)) {
      setErrMsg('手机号输入有误')
      return
    }
    if (!_isrefresh && imgVerify && imgVerifyCode && !isCode(imgVerifyCode)) {
      setErrMsg('图形验证码输入有误')
      return
    }
    if (smsVerify === true && (!smsVerifyCode || !isCode(smsVerifyCode))) {
      setErrMsg('短信验证码输入有误')
      return
    }
    const params = {
      ...submitParams,
      price: `${priceTo}`,
      mobile_number: mobileNumber
    }
    // 图形验证码参数
    if (imgVerify && imgVerifyCode && isCode(imgVerifyCode)) {
      params.verify_code = imgVerifyCode
    }
    // 短信验证码参数
    if (smsVerify && smsVerifyCode && isCode(smsVerifyCode)) {
      params.verification_code = smsVerifyCode
    }
    try {
      const result = await intentCommon(params)
      global.$rbl.push(`${submitParams.submit_sources}-提交成功`)
      $dom.popLayerSubmit()
      if (result.data.display_next_page === true) {
        const nextSubmitParams = {
          ...submitParams,
          phone: mobileNumber,
          model_name: 'discount_notify'
        }
        new UseIntentOrderExt({
          isSmsVerify: smsVerify,
          modelName: 'discount_notify',
          submitParams: nextSubmitParams,
          otherParams,
          profile: result.profile
        }).open()
        closeModal()
      } else {
        closeModal()
        const showSuccess = () => {
          new UseModalSuccess({
            msg: result.data.notice_message || getSuccessMsg('discount_notify')
          }).open()
        }
        // 未登录提交信息补充后，应该弹出登录弹窗，并发送短信验证码
        if (
          !smsVerify
          && !$cookie.get('rrc_login_phone')
          && !$cookie.get('rrc_login_token')
        ) {
          sessionstorage.set('loginBackModalInfo', {
            msg: result.data.notice_message || getSuccessMsg('discount_notify')
          })
          window.location.href = `${
            window.location.origin
          }/login?source=${encodeURIComponent(window.location.href)}&phone=${mobileNumber}`
          // new UseLogin({
          //   isAutoMsg: false,
          //   isAutoLogin: true,
          //   phone: mobileNumber,
          //   onSuccessCallBack: () => {
          //     showSuccess()
          //   }
          // }).open()
        } else {
          showSuccess()
        }
      }
    } catch (error) {
      console.log(error)
      if (error.status === 200) {
        const result = error.data
        setImgVerify('')
        setErrMsg('')
        if (result.status === 400) {
          // 图形验证码
          global.$rbl.push({
            event: 'm_verification_show',
            content: { param: 'verification' }
          })
          setImgVerify(result.image)
        } else if (result.status === 1000) {
          // 短信验证码
          setSmsVerify(true)
        } else if (result.status === 1001) {
          // 短信验证码校验失败
          setErrMsg('短信验证码输入有误')
        } else {
          message.error(result?.err_msg || result?.errMsg || '未知错误')
        }
      }
    }
  }
  return (
    <Modal
      centered
      visible={visible}
      footer={null}
      style={{ minWidth: '520px' }}
      bodyStyle={{ padding: '0px' }}
      onCancel={() => {
        closeModal()
      }}
    >
      <div className="r-detail-discount-notify-guide">
        <div className={`logo level${priceLevel}`} />
        <h2 className="title">降价通知我</h2>
        {lowPrice === priceTo ? (
          <p className="msg">
            <i className="iconfont icon-type-part-type-icon" />
            价格太低很难收到通知哦
          </p>
        ) : (
          <p className="msg">
            建议价:{floatMultiple(salePrice, 0.8).toFixed(2)}万-
            {salePrice.toFixed(2)}万
          </p>
        )}
        <Slider {...sliderOption} className="price-slider" />
        <Input
          onClick={() => {
            global.$rbl.push('car-detail_详情页线索引导弹层-降价通知_输入')
          }}
          size="large"
          className="phone"
          placeholder="请输入您的手机号"
          maxLength={11}
          suffix={<i className="iconfont icon-shouji" />}
          value={mobileNumber}
          onChange={(e) => {
            setMobileNumber(e.target.value)
          }}
        />
        {/* 防刷图形验证码 */}
        <ImgVerify
          className="image-verify"
          imgVerify={imgVerify}
          onImgVerifyCode={(code) => {
            setImgVerifyCode(code)
          }}
          onRefresh={() => {
            discountSubmit(true)
          }}
        />
        {/* 防刷短信验证码 */}
        <SmsCodeVerify
          autoSend
          phone={mobileNumber}
          smsVerify={smsVerify}
          onErrMsg={(err) => {
            setErrMsg(err)
          }}
          onSmsCode={(code) => {
            setSmsVerifyCode(code)
          }}
        />
        <p className="err-msg">{errMsg}</p>
        <Button
          size="large"
          type="primary"
          block
          className="submit"
          onClick={discountSubmit}
        >
          提交
        </Button>
      </div>
    </Modal>
  )
}

IntentDiscountNotifyGuide.propTypes = {
  visible: PropTypes.bool,
  onClose: PropTypes.func,
  submitParams: PropTypes.object,
  otherParams: PropTypes.object
}

IntentDiscountNotifyGuide.defaultProps = {
  visible: false,
  onClose: null,
  submitParams: {},
  otherParams: {}
}

function mountAnywhere(Comp, root) {
  const div = document.createElement('div');
  (root || document.body).appendChild(div)
  // 向组件注入 onClose 方法，以便组件能调用关闭
  const Clone = React.cloneElement(Comp, {
    onClose: () => {
      ReactDOM.unmountComponentAtNode(div)
      div.parentNode.removeChild(div)
    }
  })
  ReactDOM.render(Clone, div)

  return div
}

export class UseIntentDiscountNotifyGuide {
  constructor(params) {
    this.visible = false
    this.ref = null
    this.submitParams = params.submitParams
    this.otherParams = params.otherParams
  }

  open() {
    this.visible = true
    this.ref = mountAnywhere(
      <IntentDiscountNotifyGuide
        visible={this.visible}
        submitParams={this.submitParams}
        otherParams={this.otherParams}
      />
    )
    return this.ref
  }

  close() {
    this.visible = false
  }
}
export default IntentDiscountNotifyGuide
